import React from 'react';
import PropTypes from 'prop-types';
import { convertDateToDayMonthYear, convertTime } from '../../../../lib/formatDate';
import Immutable from 'immutable';

const MyOffersDesktop = ({ myOffers }) => {
  return (
    myOffers.valueSeq().map((myOffer) => (
      <React.Fragment key={ myOffer.get('id') }>
        <div className='trade-post__row' >
          <div className='trade-post__cell trade-post__one-third'>
            {myOffer.getIn(['appointment', 'office', 'name'])}
          </div>
          <div className='trade-post__cell trade-post__one-third'>
            {convertDateToDayMonthYear(myOffer.getIn(['appointment', 'scheduledOn']))}{' '}
            {convertTime(myOffer.getIn(['appointment', 'from']))}
          </div>
          <div className='trade-post__cell trade-post__one-third'>
            <span className={ 'trade-post__trade-status trade-post__trade-status--pending' } >
              Pending
            </span>
          </div>
        </div>
      </React.Fragment>
    ))
  );
};

MyOffersDesktop.propTypes = {
  myOffers: PropTypes.instanceOf(Immutable.Map).isRequired
};

export default MyOffersDesktop;



// WEBPACK FOOTER //
// ./app/components/reps/trade_post/offers/MyOffersDesktop.jsx